import * as THREE from 'three'
require('three-orbitcontrols');

import printModel from '../../../3dapps/mixins/printModel';
import { initThree, camera, renderer, currentGroup, updateMesh, incRenderCount, controls } from './initThree'
import XDialog from 'vux/src/components/x-dialog/index.vue'
import XSwitch from 'vux/src/components/x-switch/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Grid from 'vux/src/components/grid/grid.vue'
import GridItem from 'vux/src/components/grid/grid-item.vue'
import Radio from 'vux/src/components/radio/index.vue'
import Actionsheet from 'vux/src/components/actionsheet/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import XNumber from 'vux/src/components/x-number/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import Popup from 'vux/src/components/popup/index.vue'
import Toast from 'vux/src/components/toast/index.vue'
import Tab from 'vux/src/components/tab/tab.vue'
import TabItem from 'vux/src/components/tab/tab-item.vue'
import Checker from 'vux/src/components/checker/checker.vue'
import CheckerItem from 'vux/src/components/checker/checker-item.vue'
import Range from 'vux/src/components/range/index.vue'

import { SourceExporter } from './SourceExporter'
import loading from '@/components/loading';

import { baseURL } from '@/request/request.js';

function image2Base64(img) {
var canvas = document.createElement("canvas");
canvas.width = img.width;
canvas.height = img.height;
var ctx = canvas.getContext("2d");
ctx.drawImage(img, 0, 0, img.width, img.height);
var dataURL = canvas.toDataURL("image/jpg");
return dataURL;
}

let imgurl;
let imgUid;
let originWidth = 200; 
let currenteffect;
let currentbeautifyIndex;

function formateDate(date) {
return date.getFullYear() + "."
+ (date.getMonth() + 1).toString().padStart(2, "0") + "."
+ date.getDate().toString().padStart(2, "0");
}

const contextList = [
"每天都要元气满满哦", "祝你生日快乐", "快乐工作,快乐生活", "每天进步一点点"
]

function refresh3d() {

if (this.isShapeIndex < 0) {
imgurl = this.userUploadImages[this.userUploadImages.length + this.isShapeIndex];
} else {
imgurl = this.$refs['img-' + this.isShapeIndex][0];

}
updateMesh(this.draw);
}

const sampleImageUids = [
"sample,9a15e9fd6b0a4363926446a9a18be6f3",
"sample,febbec1995c94a3f8c1e7cf3229db14a",
"sample,bd5497c92f034ffc8f1a51f030950875",
"sample,ef2a9afc345f4804b67e6750408e75cf",
"sample,cd4302e9dcfd4ffa8af56d05b24f70e0",
"sample,935c758473a94ea288f0709c813055d5",
"sample,8cbed45f48954a6d942f9548ef57041f",
"sample,54bf14eb23414ad3bb5240ab73cfbfd4",
"sample,d91bdf2db495486f833d172cb3f75ebd",
"sample,354be159fd9e4ae3a3b4e80cef38a76d",
"sample,090ccdf08584441b9d3bbc65fcdf4c9c",
"sample,7ec2b0ba10684bb49e375536bd5d1f1f",
"sample,a1caf27741f04bf1970c2a92e5472173",
"sample,e128d2beb38c45d2b3a5aecddb793a41",
"sample,a79ea760d873497b861c6e4cf623b897",
"sample,e194dc126bc649afa8aa6efe54b776b9",
"sample,dae71371b786403a9db9c9b27467bbc5",
"sample,7e46627141f445698e9069ac33088523",
"sample,fde1e6c1f8584629a171a4f0def185ea",
"sample,bd53459cb3e84aa59b59973e86d1a08e"
];

let userUploadImageUids = [];

function makeImageUrl(uid, process, ext) {
return baseURL + '/makeRelief/getImage/' + uid + '/' + process + ext;
}


export default {
name: "reliefCylinder",
mixins: [printModel],
components: {
Group,
XDialog,
Actionsheet,
Grid, GridItem, XNumber, XInput, Popup, Radio, Flexbox, FlexboxItem,
Toast, XSwitch, Tab, TabItem, Checker, CheckerItem, Range, loading
},

data() {
return {
classA: true,
quotationName: "浮雕圆筒",
productType: "浮雕圆筒",
landscape: true,//竖屏状态要一直为true
showTabList: false,//底部弹窗
tabTitle: [
{
title: '图片'
}, {
title: '美化'
},
],
cur: 0, //默认选中第一个tab
showLoading: false,
boxDataOld: {
w: 150,
d: 2,//浮雕厚度
base: 2,//打底厚度
degree: 70
},
draw: {
imageWidth: 800,//手机端显示用800，后台不同，用1000
image: imgurl,
r: 20,//半径
width: 150,//宽高比
height: 2,//浮雕厚度
thickness: 2,//打底厚度
degree: 70,//角度
blur: 2,//模糊
useText: true,
text: contextList[Math.floor(Math.random() * contextList.length)],
fontSize: 60,
reverse: false,
flower: false, // 暂时不要花纹
shape: 'rect',
pillar: 'type-1', // 支柱
},
showbtnSure: true,
addCartIndex: -1,
orderIndex: -1,
isShapeIndex: 0,
userUploadImages: [],
showPrint: false,
color: "#B0B7BA",
modelSplit: false,
ShapeList: [],
showBeautify: false,
showSize: false,
showColor: false,
showText: false,
isShowText: true,
colorList: [
{
color: "#FD7D2B",
borderColor: "#C07AB8",
title: "橙色"
},
{
color: "#FF8080",
borderColor: "#EFCE07",
title: "黄色"
},
{
color: "#76BD2E",
borderColor: "#C07AB8",
title: "苹果绿"
},
{
color: "#2B62DF",
borderColor: "#9F4D95",
title: "天蓝"
},
{
color: "#B0B7BA",
borderColor: "#4F9D9D",
title: "银色"
},
{
color: "#FBAA3C",
borderColor: "#FF8080",
title: "金色"
},
{
color: "#373236",
borderColor: "#9F4D95",
title: "黑色"
},
{
color: "#FBFCF4",
borderColor: "silver",
title: "白色"
},
{
color: "#FFC4EA",
borderColor: "silver",
title: "鲜粉红"
},
{
color: "#D53825",
borderColor: "silver",
title: "红色"
},
{
color: "#F5CEB9",
borderColor: "silver",
title: "肤色"
},
],
n: 0,
text: 1,
textModel: true,
isreliefBtnIndex: -1,//顶部按钮默认
btnsList: [
{
isClick: false,
icon: require("../../../3dapps/imgs/相册.png"),
iconClick: require("../../../3dapps/imgs/相册-选中.png"),
title: "相册",
},
{
isClick: false,
icon: require("../../../3dapps/imgs/拍照.png"),
iconClick: require("../../../3dapps/imgs/拍照-选中.png"),
title: "拍照",
},
{
isClick: false,
icon: require("../../../3dapps/imgs/设置.png"),
iconClick: require("../../../3dapps/imgs/设置-选中.png"),
title: "设置",
},
{
isClick: false,
icon: require("../../../3dapps/imgs/编辑.png"),
iconClick: require("../../../3dapps/imgs/编辑-选中.png"),
title: "文字",
},
{
isClick: false,
icon: require("../../../3dapps/imgs/尺寸.png"),
iconClick: require("../../../3dapps/imgs/尺寸-选中.png"),
title: "尺寸",
},

], //按钮列表
sampleImages: sampleImageUids.map(uid => makeImageUrl(uid, 'thumb', '.jpg')),
beautifyIndex: 0,
beautifyList: [{
effect: "origin",
title: "原图"
}, {
effect: "charcoal",
title: "碳画"
}, {
effect: "negate",
title: "反相"
}, {
effect: "image-seg",
title: "去背景"
}, {
effect: "monochrome",
title: "沙画"
}, {
effect: "kuwahara",
title: "油画"
}, {
effect: "spread",
title: "磨砂"
}, {
effect: "edge",
title: "线条"
}, {
effect: 'anime',
title: '人物动漫化'
}],
drawText: "",//储存文本
showOnText: true, //是否显示文本框
}
},
mounted() {

const scope = this;
scope.showLoading = true;

var mo = function (e) {
e.preventDefault();
}



var tabList = this.$refs.tabList; 

var screenHeight = window.innerHeight;
window.onresize = function () {
var height = document.documentElement.clientHeight;

if (screenHeight !== window.innerHeight) {

tabList.style.bottom = 0 + "px";
tabList.style.position = "absolute";
} else {

tabList.style.bottom = 50 + "px";
tabList.style.position = "fixed";
}
};
window.addEventListener("resize", onresize);


var interval;


tabList.onfocus = function () {
interval = setInterval(function () {
tabList.style.bottom = 0 + "px";
tabList.style.position = "absolute";
}, 500)
};


tabList.onblur = function () {
tabList.style.bottom = 50 + "px";
tabList.style.position = "fixed";
clearInterval(interval);
};


scope.$nextTick(function () {
scope.$refs.reliefCylinder.style.paddingTop = '0px';
scope.$refs.reliefCylinder.style.overflow = 'hidden';

});

initThree(scope.$refs.canvas);


const contentDOM = scope.$refs.reliefCylinder;


const resize1 = function (e) {
if (!scope.$refs.canvas) return;


let w = scope.$refs.canvasBox.clientWidth;
let h = scope.$refs.canvasBox.clientHeight - 55;



scope.$refs.canvas.width = w; 
scope.$refs.canvas.height = h; 



camera.aspect = w / h;

camera.updateProjectionMatrix();

renderer.setSize(w, h);
}

scope.init3d(contentDOM, camera, renderer, resize1);
currenteffect = 'origin';

let image = new Image();

console.time("first load");
image.crossOrigin = "anonymous";
image.onload = function () {
scope.draw.image = image;

updateMesh(scope.draw);

scope.showLoading = false;

};
image.src = makeImageUrl(sampleImageUids[0], currenteffect, '.jpg');

},
methods: {
isTopBtn() {
if (!this.isClick) {
this.isreliefBtnIndex = -1;
this.showSize = false;
this.showText = false;
this.showTabList = false;
this.btnsList[0].isClick = false;
this.btnsList[1].isClick = false;
this.btnsList[2].isClick = false;
this.btnsList[3].isClick = false;
this.btnsList[4].isClick = false;
}
},

handler(index) {
if (index === 0) {//相册
this.isTopBtn();
this.resize();
this.beautifyIndex = 0;
this.selectFile1();
return;
} else if (index === 1) {//拍照
this.isTopBtn();
this.resize();
this.beautifyIndex = 0;
this.selectFile2();
return;
} else if (index === 2) {//设置
this.isreliefBtnIndex = index;
this.showTabList = !this.showTabList;
this.showSize = false;
this.showText = false;

if (!this.showTabList) {
this.isreliefBtnIndex = -1;
this.btnsList[2].isClick = false;


let scale = this.draw.width / originWidth;
currentGroup.scale.set(scale, scale, scale);
this.resize();
return;
}

this.btnsList[2].isClick = true;
this.btnsList[0].isClick = false;
this.btnsList[1].isClick = false;
this.btnsList[3].isClick = false;
this.btnsList[4].isClick = false;
this.resize();
return;
} else if (index === 3) {//文字
this.isreliefBtnIndex = index;
this.showText = true;

this.showTabList = false;
this.showSize = false;

this.updatedData();







this.btnsList[3].isClick = true;
this.btnsList[0].isClick = false;
this.btnsList[1].isClick = false;
this.btnsList[2].isClick = false;
this.btnsList[4].isClick = false;
this.resize();
return;
}
else if (index === 4) {//尺寸
this.isreliefBtnIndex = index;
this.showSize = true;

this.showText = false;
this.showTabList = false;

this.updatedData();







this.btnsList[4].isClick = true;
this.btnsList[0].isClick = false;
this.btnsList[1].isClick = false;
this.btnsList[2].isClick = false;
this.btnsList[3].isClick = false;
this.resize();
return;
}
},

resize() {
let w = document.documentElement.clientWidth;
let h = document.documentElement.clientHeight;
if (this.showTabList) {
let tabHeight = h * 0.24;
h = h - tabHeight;
}
camera.aspect = w / h;
camera.updateProjectionMatrix();
renderer.setSize(w, h);
incRenderCount();
},


textCanelPop() {
this.isTopBtn();
this.updatedData();
},


onChangeTextSwitch() {
const scope = this;
scope.showLoading = true;
scope.isTopBtn();
scope.isShowText = !scope.isShowText;
setTimeout(function () {
updateMesh(scope.draw);
scope.showLoading = false;
}, 50);
},


onChangeText() {
if (this.draw.text === '' || this.draw.text === null) {
this.$vux.toast.show({
text: '文本输入不能为空！',
type: "warn",
time: 2000,
position: "middle",
});
this.draw.text = "齐思印";
this.showText = true;
return;
}
this.isTopBtn();
setTimeout(() => {
this.showLoading = false;
updateMesh(this.draw);
}, 50);
},

exporter() {
let exporter = new THREE.STLExporter();
let result = exporter.parse(currentGroup, {
binary: true
});
let blob = new Blob([result], {
type: 'application/octet-stream'
});

let filename = "model.stl";
let link = document.createElement("a");
link.href = URL.createObjectURL(blob);
link.download = filename;
link.click();
},


selectFile1() {

this.$refs.btn_import1.click();
},

selectFile2() {

this.$refs.btn_import2.click();
},


selectBeautify() {
this.showText = false;
this.showSize = false;
this.showBeautify = true;
},


onsmoothsItemClick(index, effect) {
const scope = this;
let ext;
scope.beautifyIndex = index;
scope.draw.effect = effect;
currenteffect = scope.draw.effect;


this.showLoading = true;

if (scope.isShapeIndex >= 0) {
imgUid = sampleImageUids[scope.isShapeIndex];
ext = ".jpg";
} else {
imgUid = userUploadImageUids[scope.userUploadImages.length + scope.isShapeIndex].uid;
ext = userUploadImageUids[scope.userUploadImages.length + scope.isShapeIndex].ext;
}
let src = baseURL + "/makeRelief/getImage/" + imgUid + "/" + currenteffect + ext;

let img = new Image();
img.crossOrigin = "anonymous";
img.onload = function () {
scope.draw.image = img;
updateMesh(scope.draw);
scope.showLoading = false;

};
img.src = src;

currentbeautifyIndex = scope.beautifyIndex;
},



selectText() {
this.showTabList = true;
this.showText = true;
this.showBeautify = false;
this.showSize = false;
},


onTextClick() {
const scope = this;
scope.showLoading = true;
setTimeout(function () {
updateMesh(scope.draw);
scope.showLoading = false;
}, 50);
},


ontextSure() {
const scope = this;
scope.showLoading = true;
var textValue = scope.$refs.getValue.value;
setTimeout(function () {
if (textValue == "") {
scope.$vux.toast.show({
text: '文本不能为空！',
type: "warn",
time: 2000,
position: "middle",
});
scope.$refs.getValue.value = scope.draw.text;
return;
}
else {
scope.textModel = true;
scope.draw.text = textValue;
}
updateMesh(scope.draw);
scope.showLoading = false;
}, 50);
},


seleShapeItem(index) {
const scope = this;
scope.isShapeIndex = index;
this.showLoading = true;

if (scope.isShapeIndex >= 0) {
let img = new Image();
img.crossOrigin = "anonymous";
img.onload = function () {
scope.draw.image = img;
updateMesh(scope.draw);
scope.showLoading = false;
};
img.src = makeImageUrl(sampleImageUids[scope.isShapeIndex], currenteffect, '.jpg');
scope.beautifyIndex = currentbeautifyIndex;
} else {

scope.draw.image = scope.$refs['img2-' + (scope.isShapeIndex + scope.userUploadImages.length)][0];
scope.beautifyIndex = 0;
updateMesh(scope.draw);
scope.showLoading = false;

}
},

getDefaultMaterialIndex() {
let index = this.printMaterials.findIndex(m => m.materialName === "光敏树脂GenL (SLA)");

return index >= 0 ? index : 0;
},

makeStlBlob() {
let sourceExporter = new SourceExporter();
let sourceBlob = sourceExporter.makeBlob(this.draw);
return sourceBlob;

























},

getUploadUrl() {
return "/makeRelief/makeModel";
},

onFileChange1(e) {
let file = e.target.files[0];
if (!file) {
return;
};



if (file.type == "text/plain") {
this.$vux.toast.show({
text: '只能上传图片，图片格式必须为JPG格式',
type: "warn",
time: 2000,
position: "middle",
});


return;
} else {

let formData = new FormData();
formData.append("img", file);
this.$request.post("/makeRelief/addImage", formData, {
headers: {
'Content-Type': 'multipart/form-data'
}
}).then(res => {

userUploadImageUids.unshift({
uid: res.obj.img_uid,
ext: res.obj.ext
});
});
let url = URL.createObjectURL(file);
this.userUploadImages.unshift(url);
this.isShapeIndex = -this.userUploadImages.length;

this.showLoading = true;
const scope = this;
let img = new Image();
img.crossOrigin = "anonymous";
img.onload = function () {
scope.draw.image = img;
updateMesh(scope.draw);
scope.showLoading = false;
};
img.src = url;

}
},
getModelToPrint() {
return currentGroup;
},


isNoData() {
if (this.draw.r == "" && this.draw.width == "" && this.draw.height == "" && this.draw.thickness == "" && this.draw.degree == ""
|| this.draw.r == "" || this.draw.width == "" || this.draw.height == "" || this.draw.thickness == "" || this.draw.degree == "") {
this.$vux.toast.show({
text: '请检查输入是否为空！',
type: "warn",
time: 2000,
position: "middle",
});
this.draw.r = 20;
this.draw.width = 150;
this.draw.height = 2;
this.draw.thickness = 2;
this.showSize = true;
this.showLoading = false;
return;
} else if (this.draw.text < 100) {
this.$vux.toast.show({
text: '请检查输入是否为空！',
type: "warn",
time: 2000,
position: "middle",
});
this.draw.text = "齐思印";
this.showSize = true;
this.showLoading = false;
return;
}
},


updatedData() {
if (this.draw.width == "" && this.draw.height == "" && this.draw.thickness == "" && this.draw.r == ""
|| this.draw.width == "" || this.draw.height == "" || this.draw.thickness == "" || this.draw.r == "") {
this.$vux.toast.show({
text: '请检查输入是否为空！',
type: "warn",
time: 2000,
position: "middle",
});
this.showSize = true;
return;
} else if (this.draw.r < 10) {
this.$vux.toast.show({
text: '圆筒半径',
type: "warn",
time: 2000,
position: "middle",
});
return;
} else if (this.draw.r > 100) {
this.$vux.toast.show({
text: '圆筒半径',
type: "warn",
time: 2000,
position: "middle",
});
return;
} else if (this.draw.width < 100) {
this.$vux.toast.show({
text: '最小宽度不能小于100毫米',
type: "warn",
time: 2000,
position: "middle",
});
return;
} else if (this.draw.width > 400) {
this.$vux.toast.show({
text: '最大宽度不能大于400毫米',
type: "warn",
time: 2000,
position: "middle",
});
return;
} else if (this.draw.height < 1) {
this.$vux.toast.show({
text: '最小浮雕厚度不能小于1毫米',
type: "warn",
time: 2000,
position: "middle",
});
return;
} else if (this.draw.height > 5) {
this.$vux.toast.show({
text: '最大浮雕厚度不能大于5毫米',
type: "warn",
time: 2000,
position: "middle",
});
return;
} else if (this.draw.thickness < 1) {
this.$vux.toast.show({
text: '最小底厚不能小于1毫米',
type: "warn",
time: 2000,
position: "middle",
});
return;
} else if (this.draw.thickness > 3) {
this.$vux.toast.show({
text: '最大底厚不能大于3毫米',
type: "warn",
time: 2000,
position: "middle",
});
return;
}
setTimeout(() => {
this.showLoading = false;
updateMesh(this.draw);
}, 50);
},


canelPop() {
this.isTopBtn();
this.updatedData();
},


isSure() {
this.showLoading = true;
this.updatedData();
},


touchstart() {
this.isTopBtn();
this.resize();
this.updatedData();
},


print() {
this.modelSplit = true;
this.showSize = false;
this.showLoading = true;

this.isNoData();



if (this.lowPrice == 0 && this.total <= 5 || this.total == 5) {
this.showlow = true;
this.showStyle = false;
this.showlowpriceHeight = true;

}
if (this.lowPrice == 1 && this.total > 5 || this.total > 5 || this.lowPrice == "") {
this.showlow = false;
this.showStyle = true;
this.showlowpriceHeight = false;

}

if (currentGroup) {

if (!this.$common.getCookie('_token')) {
this.$router.push({
path: '/login',
query: {
fullPath: this.$route.fullPath
}
})

this.afterLoginShow = "print";
this.showLoading = false;
} else {
this.$nextTick(function () {

this.showPrint = true;
this.makeModelForPrint();
const scope = this;
this.getPrice().then(() => {
scope.showLoading = false;
});
});
}
} else {
this.refresh3d();
this.showLoading = false;
}

if (!currentGroup) {
this.$vux.toast.show({
text: '3D浮雕不能为空！',
type: "warn",
time: 2000,
position: "middle",
});
}
},
},
watch: {
draw: {//判断字体的长度，固定为20
ontextSure() {
var _this = this;
var _sum = 20; 
_this.$refs.getValue.setAttribute("maxlength", _sum);
_this.text = _sum - _this.$refs.getValue.value.length;

}
},
'draw.text': function () {
if (this.draw.text == "") {
this.showbtnSure = false;
return;
} else {
this.showbtnSure = true;
}
}
},
}


// WEBPACK FOOTER //
// ./src/views/reliefCylinder/scripts/reliefCylinder.js